export enum BlockCategory {
  Start = 'Start',
  Logic = 'Logic',
  Data = 'Data',
  Experience = 'Experience',
  Integration = 'Integration',
  Ai = 'Ai',
  Export = 'Export',
  Skill = 'Skill',
  Obsolete = 'Obsolete',
  Placeholder = 'Placeholder',
}

export const BLOCK_CATEGORY_NAMES: Record<BlockCategory, string> = {
  [BlockCategory.Start]: 'Start',
  [BlockCategory.Logic]: 'Logic',
  [BlockCategory.Data]: 'Data',
  [BlockCategory.Experience]: 'Experience',
  [BlockCategory.Integration]: 'Integration',
  [BlockCategory.Ai]: 'AI',
  [BlockCategory.Export]: 'Export',
  [BlockCategory.Skill]: 'Skill',
  [BlockCategory.Obsolete]: 'Obsolete',
  [BlockCategory.Placeholder]: 'Placeholder',
};

/** Whether a block may cause side effects during test runs. */
export enum BlockSafetyLevel {
  Safe = 'Safe',
  Unsafe = 'Unsafe',
}

/**
 * This variant is restricted to very specific use cases.
 * You must get approval from design before adding to this list.
 */
export enum BlockCustomIconVariant {
  Iterator = 'Iterator',
  SubFlow = 'SubFlow',
  Script = 'Script',
  Text = 'Text',
}

export enum BlockLifeCycle {
  Internal = 'Internal',
  Published = 'Published',
  Beta = 'Beta',
  Developer = 'Developer',
  Retired = 'Retired',
  Obsolete = 'Obsolete',
}
